/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as ProgramService} from "../../../Services/ProgramService";
import {StreamBankContext} from "../../../App/StreamBankContext";
import {StreamBankLink} from "../../../Components/Common/StreamBankLink";
import React from "react";

export class ProgramFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			program: null
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		ProgramService.GetProgram(this.props.Value)
			.then(async (x) => {
				const program = x.result;

				// Prime the parent before rendering so the subtitle names it on
				// first paint rather than filling in a beat later. The parent may
				// not be readable to this user; the subtitle then degrades to the
				// bare level label, which must not block rendering the program.
				if (program?.parentProgramId) {
					await ProgramService.FindById(program.parentProgramId).catch(() => null);
				}

				this.setState({program});
			})
			// an unreadable program renders as "N/A"; keep that degradation quiet
			.catch(() => null);
	}

	@autobind
	getContext() {
		let context = new StreamBankContext();

		if (this.state.program) {
			if (this.state.program.parentProgramId) {
				context = new StreamBankContext(
					(this.state.program.parentSlug || this.state.program.parentProgramId),
					(this.state.program.slug || this.state.program.programid)
				);
			} else {
				context = new StreamBankContext(
					(this.state.program.slug || this.state.program.programid)
				);
			}
		}

		return context;
	}

	@autobind
	_render() {
		let context = this.getContext();
		let program = this.state.program;

		// Only subprograms need the parent named; a top-level program's level is
		// already evident from where it is being shown.
		let subtitle = program?.parentProgramId ? ProgramService.GetSubtitle(program) : null;

		return <div className="sb-autocomplete-item">
			<div>
				<div className="title">
					<StreamBankLink Context={context} Tool={"summary"} Disabled={program == null}>
						{program ? program.name : "N/A"}
					</StreamBankLink>
				</div>
				{subtitle != null ? <div className="subtitle">{subtitle}</div> : null}
			</div>
		</div>;
	}
}